import * as LowcompIndex from 'lowcomp/plugins/index-series/indexS';
import { MemberTimeProvider } from 'lowcode/utils/context/memberTimeZone';
import MemberGloData from 'lowcode/utils/MemberGloData';
import Product from 'lowcode/pages/product';
import { EcoProvider } from 'lowcode/utils/context/ecocredits';
import { queryEditorDetailOnline } from 'lowcode/utils/service';
import * as LowcompMember from 'lowcomp/plugins/member/indexS';
import type { GetServerSidePropsContext, NextPage } from 'next';
import PageLayout from '@/components/PageLayout';
import SEOlinksA from '@/components/SEOlinksA';
import seoconfig from '@/seoconfig/members-power-deals';
import { redirectTo404 } from '@/utils';
import { useGlobal } from '@/utils/useGlobal';
import getLocal from '@/app/utils/getLocal';
import { onLogin } from '@/utils/cookie';
import { useLang } from '@/i18n';
import './index.scss';
import { getAppSession } from '@/utils/appGetToken';

const allTemp = {
    ...LowcompIndex,
    ...LowcompMember,
};

// AppreciationDay
const MembersPowerDeals: NextPage = ({ isLogin, SEO, id, data }: any) => {
    const { t } = useLang('ecocredits');
    const { isApp } = useGlobal();
    const { locale } = getLocal();

    if (isApp) {
        // efBridge.registerHandler('getAppMsg', (res) => {
        //     if (!res) return;
        //     const dataSet = {
        //         token: res.token.replace('Bearer ', ''),
        //         user: {},
        //     };
        //     onLogin(dataSet);
        // });
        const token = getAppSession();
        const dataSet = {
            token,
            user: {},
        };
        onLogin(dataSet);
    }

    // const IS_PROD: boolean = process.env.NEXT_PUBLIC_MODY === 'prd';
    // // 代码写死的非配置化站点
    // const IS_FIX_SITES: boolean = ['us', 'ca'].includes(locale);

    return (
        <>
            <SEO title={t('seo.title') || t('join_title')} description={t('seo.desc')} />
            <SEOlinksA locale={String(locale)} list={['us', 'ca']} pathname={seoconfig.url} />
            <style jsx global>
                {`
                    .ant-message {
                        z-index: 9999999;
                    }
                    .ant-modal-root {
                        z-index: 2132;
                    }
                    .glo-editor-modal-show {
                        z-index: 2133;
                    }
                `}
            </style>
            <PageLayout isNoFixed>
                {/* {IS_FIX_SITES ? (
                    <MonthlyProvider state={initState}>
                        <MonthlyCompoment />
                    </MonthlyProvider>
                ) : (
                    <EcoProvider>
                        <Product id={id} data={data} allTemp={allTemp} />
                    </EcoProvider>
                )} */}
                <MemberTimeProvider>
                    <MemberGloData isOpenA={true} />
                    <EcoProvider>
                        <Product id={id} data={data} allTemp={allTemp} />
                    </EcoProvider>
                </MemberTimeProvider>
            </PageLayout>
        </>
    );
};

export default MembersPowerDeals;

export async function getServerSideProps({ locale, req, query }: GetServerSidePropsContext) {
    const naList = ['us', 'ca'];

    // 非白名单404
    if (!naList.includes(locale as string)) {
        return redirectTo404();
    }
    // 结束后重定向到 ecocredits页面 (不是预热也不是活动阶段)， 产品说去掉，配合配置化页面
    // if (!status && !debug && naList.includes(locale as string)) {
    //     return {
    //         redirect: {
    //             destination: `/${locale}/ecocredits`,
    //             permanent: true,
    //         },
    //     };
    // }

    // jp 为配置页面
    let data = {
        thePage: {},
        theTemp: [],
        theData: {},
        theAttr: {},
        sqlData: {},
    };
    const id = 'members-power-deals';
    try {
        data = await queryEditorDetailOnline(id, locale as string);
    } catch (e: any) {}

    // 获取登陆信息
    const userInfoJson = req.cookies?.userInfo || '';
    let isLogin = false;
    try {
        const userInfo = JSON.parse(userInfoJson);
        isLogin = !!userInfo.token;
    } catch {}

    return {
        props: {
            isLogin,
            id,
            data,
        },
    };
}
